module.exports = __webpack_public_path__ + "img/img-3.5e11749c.webp";